<script context="module" lang="ts">
  import type { IconType } from "$components/+shared/OVIcon/OVIcon";

  export type DropdownAction = {
    title: string;
    icon: IconType;
    onClick: () => void;
  };
</script>

<script lang="ts">
  import InnerContainer from "../internal/InnerContainer.svelte";
  import FieldContainer from "../internal/FieldContainer.svelte";
  import TitleDescription from "../internal/TitleDescription.svelte";
  import OVIcon from "$components/+shared/OVIcon/OVIcon.svelte";
  import cx from "classnames";

  export let title: string;
  export let description: string = "";
  export let icon: IconType | undefined = undefined;
  export let reverseOrder: boolean = false;
  export let active: boolean | undefined = undefined;
  export let closeOnTrigger: boolean = true;
  export let danger: boolean = false;
  export let tooltipCopy: string = "";
</script>

<FieldContainer {title} {closeOnTrigger}>
  <button on:click class="w-full">
    <InnerContainer {reverseOrder} {description} {active} {danger} {tooltipCopy}>
      {#if icon}
        <OVIcon
          {icon}
          size={cx({ "w-3.5 h-3.5": reverseOrder, "w-4 h-4": !reverseOrder })}
          class={cx(
            { "mt-0.5": description, "ml-auto": reverseOrder },
            "opacity-70 dark:opacity-60"
          )}
        />
      {/if}

      <TitleDescription {title} {description} />
    </InnerContainer>
  </button>
</FieldContainer>
